import { HashRouter, Route, Switch } from "react-router-dom";
import "./body.scss";

import React, { lazy } from "react";
import { ENUM_PAGE } from "src/libraries/enums/pages";
import { HomeScreen } from "src/pages/home/home-screen";
import { MerchantScreen } from "src/pages/merchant/merchant-screen";
import { TransactionScreen } from "src/pages/transaction/transaction-screen";
import { BankScreen } from "src/pages/bank/bank-screen";
import { ChannelScreen } from "src/pages/channel/channel-screen";
import { TestScreen } from "src/pages/test/test_page";
// const AdminScreen = lazy(() => import("src/pages/admin-management/admin-management-screen"))

const BodyComponent = () => {
  return (
    <div className="main-body-ctn">
      <Switch>
        <Route exact path={ENUM_PAGE.HOME}>
          <HomeScreen />
        </Route>
        <Route path={ENUM_PAGE.MERCHANT}>
          <MerchantScreen />
        </Route>
        <Route path={ENUM_PAGE.TRANSACTION}>
          <TransactionScreen />
        </Route>
        <Route path={ENUM_PAGE.BANK}>
          <BankScreen />
        </Route>
        <Route path={ENUM_PAGE.CHANNEL}>
          <ChannelScreen />
        </Route>
        {/* <Route path={ENUM_PAGE.TEST}>
          <TestScreen />
        </Route> */}
      </Switch>
    </div>
  );
};

export default BodyComponent;
